
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"registerAndLogin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"FullName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"CompanyAddress"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"HomeAddress"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ContactNo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ICPassportNo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"StaffId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"TenantName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"AttachmentsId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registerAndLogin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"FullName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"FullName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"CompanyAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"CompanyAddress"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"HomeAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"HomeAddress"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ContactNo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ContactNo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ICPassportNo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ICPassportNo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"StaffId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"StaffId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"Type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"TenantName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"TenantName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"AttachmentsId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"AttachmentsId"}}}]}}],"directives":[]}]}}],"loc":{"start":0,"end":606}};
    doc.loc.source = {"body":"mutation registerAndLogin(\r\n  $FullName: String!\r\n  $CompanyAddress: String!\r\n  $HomeAddress: String!\r\n  $ContactNo: String!\r\n  $ICPassportNo: String!\r\n  $Email: String\r\n  $StaffId: String\r\n  $Type: Float!\r\n  $TenantName: String\r\n  $AttachmentsId: String\r\n) {\r\n  registerAndLogin(\r\n    data: {\r\n      FullName: $FullName\r\n      CompanyAddress: $CompanyAddress\r\n      HomeAddress: $HomeAddress\r\n      ContactNo: $ContactNo\r\n      ICPassportNo: $ICPassportNo\r\n      Email: $Email\r\n      StaffId: $StaffId\r\n      Type: $Type\r\n      TenantName: $TenantName\r\n      AttachmentsId: $AttachmentsId\r\n    }\r\n  )\r\n}\r\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["registerAndLogin"] = oneQuery(doc, "registerAndLogin");
        
